import ProductsForm from "../components/layout/products/ProductsForm";

const ProductsPage = (props) => {
  return <ProductsForm content1={props.content1} />;
};

export default ProductsPage;
